import React from 'react';

export default () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 14.5C0 11.7386 2.23858 9.5 5 9.5H11C13.7614 9.5 16 11.7386 16 14.5C16 15.6046 15.1046 16.5 14 16.5H2C0.895431 16.5 0 15.6046 0 14.5Z"
        fill="white"/>
      <rect x="4" y="0.5" width="8" height="8" rx="4" fill="white"/>
    </svg>
  );
};
